import React from "react";

function ChoicePrompt({ question, options, onSelect }) {
	return (
		<div className="afs-review__exec-prompt">
			<span className="afs-review__exec-prompt-question">{question}</span>
			<div className="afs-review__exec-prompt-options">
				{options.map(function (option) {
					return (
						<button key={option.id} className="afs-review__exec-prompt-btn" onClick={function () { onSelect(option.id); }}>
							{option.label}
						</button>
					);
				})}
			</div>
		</div>
	);
}

export default ChoicePrompt;
